import React from "react";
import { AuthProvider } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";

// -- Default config: Dev environment (used in deployed dev site)
const authority = process.env.REACT_APP_AUTH_URL || "https://dev-parqai-auth.azurewebsites.net";
const client_id = process.env.REACT_APP_AUTH_CLIENT_ID || "parqai-web-local";

// -- Optional: Local test config (uncomment to use localhost IdP)
// const authority = process.env.REACT_APP_AUTH_URL || "https://localhost:5001/";
// const client_id = process.env.REACT_APP_AUTH_CLIENT_ID || "parqai-web";

const oidcConfig = {
  authority,
  client_id,
  redirect_uri: `${window.location.origin}/callback`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  response_type: "code",
  scope: 'openid profile email role clientId pmf.api.read pmf.api.write lotId permission name clientAccountId tenantId offline_access',
  automaticSilentRenew: true,
  monitorSession: false,
  loadUserInfo: true,
  filterProtocolClaims: true,
  userStore: new WebStorageStateStore({ store: sessionStorage }),
  // Strip code/state from the URL once the callback is processed, so a stale
  // code is never re-exchanged and hasAuthParams() reflects reality.
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

export function OidcProviderWrapper({ children }) {
  return <AuthProvider {...oidcConfig}>{children}</AuthProvider>;
}
